module.exports = __webpack_public_path__ + "static/media/gucciflora.7a619fdb.png";